module.exports = __webpack_public_path__ + "img/7597adf9806402ea9acc290a72c0b58f.png";